import { useEffect } from 'react';
import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import {
  CheckoutPayment,
  CheckoutSummary,
  useCheckoutColors,
  useCheckoutNavigation
} from '../components';
import { COMPONENT_NAME } from './constants';
import type { CheckoutComponentLayoutDistilledProps } from './types';

export function WideLayout({
  paymentComponentProps,
  summaryComponentProps
}: CheckoutComponentLayoutDistilledProps) {
  const { resetCheckoutStep } = useCheckoutNavigation();
  const { backgroundColor } = useCheckoutColors();

  useEffect(() => {
    resetCheckoutStep();
  }, []);

  return (
    <WideBackground $backgroundColor={backgroundColor}>
      <WideContentPayment>
        <CheckoutPayment {...paymentComponentProps} />
      </WideContentPayment>
      <WideContentSummary>
        <CheckoutSummary {...summaryComponentProps} />
      </WideContentSummary>
    </WideBackground>
  );
}

const WideBackground = styled.div.attrs<{
  $backgroundColor: string;
}>({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'background-wide'
  })
})`
  position: relative;

  display: flex;
  flex-direction: row;

  width: 100%;
  height: 100%;
  min-height: 600px;
  max-height: min(90vh, 100%);

  overflow: hidden;
  border-radius: 20px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

const WideContentPayment = styled.div.attrs({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'content-wide',
    modifier: 'payment'
  })
})`
  flex-basis: 62%;
  max-width: 62%;
`;

const WideContentSummary = styled.div.attrs({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'content-wide',
    modifier: 'summary'
  })
})`
  flex-basis: 38%;
  max-width: 38%;
`;
